export default "__VITE_ASSET__9$E78sgY__"